module.exports = __webpack_public_path__ + "static/media/my-debts-banner.8f038ce8.png";